<template>
    <div class="ppv2-flex ppv2-flex-wrap ppv2-mb-8 ppv2-w-full" :style="{ gap: normalizeSize(16, true) }">
        <StatsCard
            v-for="item in navItems"
            :key="item.key"
            class="ppv2-flex-1 ppv2-min-w-[200px]"
            :isActive="activeTab === item.key"
            :count="stats[item.countKey] || 0"
            :label="item.label"
            :icon="item.icon"
            @click="$emit('click', item.key)"
        />
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'

import StatsCard from '../Food/StatsCard.vue'
import { Tag, FolderTree, Package, List } from 'lucide-vue'

export default {
    name: 'ProductStatsNavigation',
    components: {
        StatsCard,
    },
    props: {
        activeTab: {
            type: String,
            required: true,
        },
        stats: {
            type: Object,
            required: true,
            default: () => ({
                products: 0,
                categories: 0,
                suppliers: 0,
                brands: 0,
            }),
        },
        canConsultProducts: {
            type: [Boolean, String],
            default: true,
        },
        canConsultCategories: {
            type: [Boolean, String],
            default: true,
        },
        canConsultSuppliers: {
            type: [Boolean, String],
            default: true,
        },
        canConsultBrands: {
            type: [Boolean, String],
            default: true,
        },
    },
    computed: {
        navItems() {
            const items = []

            if (String(this.canConsultProducts) !== 'false') {
                items.push({
                    key: 'products',
                    countKey: 'products',
                    label: this.$t('products.stats.products') || 'Produits',
                    icon: Tag,
                })
            }

            if (String(this.canConsultCategories) !== 'false') {
                items.push({
                    key: 'categories',
                    countKey: 'categories',
                    label: this.$t('products.stats.categories') || 'Catégories',
                    icon: FolderTree,
                })
            }

            if (String(this.canConsultSuppliers) !== 'false') {
                items.push({
                    key: 'suppliers',
                    countKey: 'suppliers',
                    label: this.$t('products.stats.suppliers') || 'Fournisseurs',
                    icon: Package,
                })
            }

            if (String(this.canConsultBrands) !== 'false') {
                items.push({
                    key: 'brands',
                    countKey: 'brands',
                    label: this.$t('products.stats.brands') || 'Marques',
                    icon: List,
                })
            }

            return items
        },
    },
    methods: {
        normalizeSize,
    },
}
</script>
